import * as React from "react";
import { IFormSectionQualifierPresentationModel } from "../../../../presenter/form/model/FormSectionQualifierPresentationModel";
import { IFormSectionPresentationModel } from "../../../../presenter/form/model/FormSectionPresentationModel";
import { IReferenceValue } from "../../../../model/form/ReferenceValue";
import { IFormInputValueValidationError } from "../../../../model/validation/FormInputValueValidationError";
import { IFormQualifierAttributePresentationModel } from "../../../../presenter/form/model/FormQualifierAttributePresentationModel";
import { Text, View, Font } from "@react-pdf/renderer";
import DisplayFormQualifierAttributePDF from "./DisplayFormQualifierAttributePDF";
import SagoeUi from "../../../assets/fonts/623c7118249e082fe87a78e08506cb4b.ttf";
import SagoeUiBold from "../../../assets/fonts/60570a3f64a1fece44ebf71b43617029.ttf";

export interface State {}

export interface Props {
  formSectionQualifier: IFormSectionQualifierPresentationModel;
  parentSection: IFormSectionPresentationModel;
  translate: any;
  getReferenceValues: any;
  referenceLoading?: boolean;
  referenceValueList?: IReferenceValue[];
  isEditableForm: boolean;
  changeFormAttribute: any;
  validationErrors?: IFormInputValueValidationError[];
  formTypeCode: string;
  formQualifierValidationErrors?: number[];
  styles: any;
}

export default class DisplayFormSectionQualifierPDF extends React.Component<
  Props,
  State
> {
  render() {
    const {
      formSectionQualifier,
      parentSection,
      translate,
      getReferenceValues,
      referenceValueList,
      isEditableForm,
      changeFormAttribute,
      validationErrors,
      formTypeCode,
      styles
    } = this.props;
    const sortQualifierAttributesByOrderNumberDisplay = (
      qualifierAttributeList: IFormQualifierAttributePresentationModel[]
    ) => {
      return qualifierAttributeList.sort((a, b) => {
        return a.orderNumberInsertDisplay - b.orderNumberInsertDisplay;
      });
    };

    const renderAttributesInline = () => {
      let attributeRenderList: JSX.Element[] = [];
      if (formSectionQualifier.attributes) {
        let sortedAttributes = sortQualifierAttributesByOrderNumberDisplay(
          formSectionQualifier.attributes
        );

        sortedAttributes.forEach(
          (
            formQualifierAttribute: IFormQualifierAttributePresentationModel
          ) => {
            attributeRenderList.push(
              <DisplayFormQualifierAttributePDF
                rowIndex={0}
                key={`pdf-attribute-${formQualifierAttribute.id}`}
                translate={translate}
                attribute={formQualifierAttribute}
                getReferenceValues={getReferenceValues}
                referenceValueList={referenceValueList}
                isEditableForm={isEditableForm}
                changeFormAttribute={changeFormAttribute}
                validationErrors={validationErrors}
                formTypeCode={formTypeCode}
                qualifierCode={formSectionQualifier.qualifierCode}
                width={formSectionQualifier.width}
                styles={styles}
                isParentQualifierMultiAttribute={
                  (formSectionQualifier.attributes?.length || 0) > 1
                }
              />
            );
          }
        );
      }
      return attributeRenderList;
    };
    return (
      <View style={styles.qualifier}>
        <Text style={styles.subheader}>
          {`${
            formSectionQualifier.orderNumberVisible
              ? `${parentSection.orderNumber}.${formSectionQualifier.orderNumber}`
              : ""
          } ${
            formSectionQualifier.labelVisible && formSectionQualifier.label
              ? formSectionQualifier.label
              : formSectionQualifier.qualifierName
          }${
            formSectionQualifier.additionalComment
              ? `(${formSectionQualifier.additionalComment})`
              : ""
          }`}
        </Text>
        <View style={styles.attribute}>{renderAttributesInline()}</View>
      </View>
    );
  }
}


Font.register({
  family: "Segoe UI",
  fonts: [
    {
      src: SagoeUiBold,
      fontWeight: "bold"
    },
    { src: SagoeUi }
  ]
});
